import {
	backButton,
} from '@tma.js/sdk'
import {
	useEffect,
} from 'react'

export const useTelegramBackButton = (enabled: boolean, onClick: () => void): void => {
	useEffect(() => {
		if (!backButton.isSupported()) {
			return
		}

		backButton.mount()

		if (!enabled) {
			backButton.hide()

			return
		}

		backButton.show()

		const offClick = backButton.onClick(onClick)

		// eslint-disable-next-line consistent-return
		return (): void => {
			offClick()
			backButton.hide()
		}
	}, [enabled, onClick])
}

